import React from 'react'
import MyButton from '../../../UI/form/MyButton'
import { useState } from 'react'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { changeWorkPlaceAPI } from '../../../../api/workPlace/workPlaceAPI'
import ErrorMessage from '../../../../helpers/message/ErrorMessage'
import SuccessMessage from '../../../../helpers/message/SuccessMessage'

const UserWorkPlaceConfirm = ({ scaned, type, setOpen }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const endWorkPlace = () => {
        setError('')
        setLoading(true)
        changeWorkPlaceAPI({ scaned }).then(data => {
            setLoading(false)
            setOpen(false)

            // Оновлюємо сторінку щойно відбулась фіксація на роботі
            window.location.reload();
        }).catch(e => {
            setError(responseError(e))
            // setErrorMain(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <ErrorMessage 
            error={error}
        />

        {
            scaned ?
                <MyButton
                    onClick={endWorkPlace}
                    disabled={loading ? true : false}
                >
                    Підтвердити
                </MyButton>
            : ''
        }
    </div>
  )
}

export default UserWorkPlaceConfirm